var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveTrackingUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{fill:rgba(234,237,242,0.66);}.c{clip-path:url(#a);}.d{fill:#aaaeb3;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(-0.333 -0.334)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-248 -221)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(248 221)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(253.333 226.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.123 0.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M118.137,14.308c2.923,0,5.294-2.774,5.294-6.2,0-4.745-2.37-6.2-5.294-6.2s-5.294,1.451-5.294,6.2C112.843,11.534,115.213,14.308,118.137,14.308Z",
    transform: "translate(-106.332 -1.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M23.494,230.249l-2.671-6.016a1.34,1.34,0,0,0-.6-.643l-4.145-2.158a.267.267,0,0,0-.284.024,6.539,6.539,0,0,1-7.972,0,.267.267,0,0,0-.284-.024L3.39,223.59a1.34,1.34,0,0,0-.6.643L.115,230.249a1.335,1.335,0,0,0,1.22,1.877H22.274a1.335,1.335,0,0,0,1.221-1.877Z",
    transform: "translate(0.001 -208.737)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTrackingUser);
export default __webpack_public_path__ + "static/media/live_tracking_user.53378d5ac50e431d293de457536ea4c6.svg";
export { ForwardRef as ReactComponent };